<template>
  <div>
    <CCard>
      <CCardHeader>
        <strong>{{$t('editPassn.paxDet')}}</strong>
      </CCardHeader>
      <CCardBody>
        <div>
          <CRow class="sp">
            <CCol></CCol>
            <CCol>
              <strong>{{ $t("editPassn.pName") }}</strong>
            </CCol>
            <CCol>
              <strong>{{ $t("editPassn.gender") }}</strong>
            </CCol>
            <CCol>
              <strong>{{ $t("editPassn.rep_doc_id") }}</strong>
            </CCol>

            <CCol>
              <strong>{{ $t("editPassn.dob") }}</strong>
            </CCol>
            <CCol>
              <strong>{{ $t("editPassn.nat") }}</strong>
            </CCol>

            <CCol>
              <strong>{{ $t("editPassn.tkt_num") }}</strong>
            </CCol>
          </CRow>
        </div>

        <div v-if="passengersList && passengersList.length">
          <CRow
            @click="isExchange? (pax.canExchange && !viewOnly? onPaxSelection(pax):null) : (pax.canRefund  && !viewOnly? onPaxSelection(pax):null)"
            class="sp"
            :class="isExchange?{ disable: !pax.canExchange|| viewOnly } : { disable: !pax.canRefund || viewOnly}"
            v-for="(pax, index) in passengersList"
            :key="'i' + index"
          >
            <CCol>
              <CIcon v-if="pax.isSelected" name="cil-star"></CIcon>

              <CIcon v-else name="cil-ban"></CIcon>
            </CCol>
            <CCol>
              <span>{{ pax.title + " " + pax.firstName + " " + pax.lastName }}</span>
            </CCol>
            <CCol>
              <span>{{ gender[pax.gender] }}</span>
            </CCol>
            <CCol>
              <span>{{ pax.DocumentId }}</span>
            </CCol>

            <CCol>
              <span>{{ pax.dob | formatDate }}</span>
            </CCol>
            <CCol>
              <span>{{ pax.nationality }}</span>
            </CCol>

            <CCol>
              <span>{{ pax.ticketNumber }}</span>
            </CCol>
          </CRow>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import router, { navigate, goBack } from "./../../../../router/index";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage
} from "./../../../../util/apiValidate";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES
} from "./../../../../config/API_DATA";

import { cloneDeep } from "./../../../../util/util";
import {
  COMPONENT_NAME,
  PATHNAME,
  POSTPAID_TYPE,
  ALL_CLIENT_CODE
} from "./../../../../util/constants";
import BaseConfiguration from "./../../../../config/base.js";
import Logger from "./../../../../services/logger";
export default {
  name: COMPONENT_NAME.C_EDIT_PASSN,

  props: {
    lsPassn: {
      type: Array,
      default: null
    },


    viewOnly:{

      type:Boolean,
      default:false

    },


    isExchange:{
      type:Boolean,
      default:false
    }
  },

  data: () => {
    return {
      passengersList: [],


      gender:{
        1:'Male',
        2:'Female'
      }
    };
  },

  watch: {
    lsPassn(val) {
      if (val) this.passengersList = val;
    }
  },

  methods: {
    onPaxSelection(pPaxObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("onPaxSelection");

        if (pPaxObj && pPaxObj.isSelected != null) {
          pPaxObj.isSelected = !pPaxObj.isSelected;
        } else {
          pPaxObj.isSelected = true;
        }
        this.passengersList = cloneDeep(this.passengersList);

        this.$emit("input", this.passengersList);
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_EDIT_PASSN,
          "error in onPaxSelection",
          err.toString(),
          "onPaxSelection",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    }
  },

  beforeUpdate() {
    //     if (this.lsPassn && this.lsPassn.length) {
    //   this.passengersList = cloneDeep(this.lsPassn);
    // }
  },
  created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");

      if (this.lsPassn && this.lsPassn.length) {
        this.passengersList = this.lsPassn;
      }
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.C_EDIT_PASSN,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  }
};
</script>

<style>
.sp {
  margin-bottom: 23px;
}

.disable {
  background-color: #ced2d8;
}
</style>
